<template>
  <div class="container">
        <div class="d-grid gap-2 mb-1 mt-1">
          <button class="btn btn-default btn-sm btn-primary" @click="$router.back()"> <i class="bi bi-arrow-left-circle"></i> Geri Dön </button>
        </div>    
        <div class="position-relative">
          <div v-if="loading" class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
            <div class="spinner-border"></div>
          </div>
          <img
            :src="bookUrl"
            class="img-fluid"
            @load="loading=false"
            @error="loading=false"
          />
        </div>
        <div class="d-grid gap-2 mb-1 mt-1">
          <button class="btn btn-default btn-sm btn-primary" @click="$router.back()"> <i class="bi bi-arrow-left-circle"></i> Geri Dön </button>
        </div> 
  </div>
</template>

<script>
export default {
  name: 'BookViewPage',
  components: {
  },
  data() {
    return {
      loading: true
    };
  },
  computed:{
      bookUrl() {
        return decodeURIComponent(this.$route.params.url)
      }
  },
  methods: {
   
  },
  onLoad() {
    setTimeout(() => (this.isLoading = false), 200);
  }

}
</script>
<style></style>